import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ButtonModule, IconModule, SpinnerDirective } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';

import { GetPaginationRes } from '@pp/core/entities';

import { Notification, NotificationType } from '../../notifications.entities';
import { NotificationComponent } from './notification/notification.component';

@Component({
  selector: 'pp-notifications-list',
  imports: [CommonModule, ButtonModule, IconModule, NotificationComponent, SpinnerDirective, TranslateModule],
  templateUrl: './notifications-list.component.html',
  styleUrl: './notifications-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsListComponent {
  readonly messages = input<GetPaginationRes<Notification>>();
  readonly type = input<NotificationType>();
  readonly loading = input<boolean>();
  readonly loadMore = output<void>();
  readonly markAsRead = output<Notification>();

  get array(): Array<number> {
    const count = 3;

    return Array.from({ length: count });
  }
}
